import { useEffect } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// F8 (paridad demo) — helper compartido para los toggles de clase en <body> que el
// demo hace con `document.body.classList.toggle(...)` dentro de un useEffect propio
// por cada caso (PlataformaPage.tsx : 40-57): `body.frontline-mobile-mode` y
// `body.plataforma-admin-mode` (H-97/H-102). Se extrae a un hook único para no repetir
// el mismo patrón de efecto + limpieza en cada consumidor (AppLayout.tsx, App.tsx).
// ─────────────────────────────────────────────────────────────────────────────

/** Añade/retira `className` en `document.body` mientras `active` sea true. Limpia al desmontar. */
export function useBodyClass(className: string, active: boolean): void {
  useEffect(() => {
    if (!active) return;
    document.body.classList.add(className);
    return () => {
      document.body.classList.remove(className);
    };
  }, [className, active]);
}

export default useBodyClass;
